import React, { Fragment } from 'react';
import { Divider } from '@ui';
import FirstRow from './components/FirstRow';
import FourthRow from './components/FourthRow';
import SecondRow from './components/SecondRow';
import ThirdRow from './components/ThirdRow';

export const OnlineBankingFields = ({ children }) => {
    return (
        <Fragment>
            <FirstRow />
            <SecondRow />
            <ThirdRow />
            <FourthRow />
            <Divider margin='32px 0' />
            {children}
        </Fragment>
    );
};
